<template>
  <div class="intro-container">
    <StepTitle>
      Onze Moederdag actie is helaas afgelopen
    </StepTitle>
    <SubTextContainer>
      We wensen je mama, plusmama of oma alsnog een hele fijne moederdag.
      <br class="em_hide" />En we hopen dat jullie snel samen kunnen vieren.
    </SubTextContainer>
    <div class="image-container">
      <img
        class="intro-image"
        src="./images/start-image@2x.png"
        alt="preview"
      />
    </div>
    <div class="op-bezoek-tekst">
      Maak er een gezellige avond van en kijk samen een film of serie op VTM GO.
    </div>
    <ButtonContainer>
      <a href="https://vtm.be/vtmgo" rel="noopener noreferrer" target="_parent">
        <img src="./images/svg/vtm-go-btn.svg" alt="naar vtm go" />
      </a>
    </ButtonContainer>
  </div>
</template>
<script>
import StepTitle from '../../StepTitle';
import SubTextContainer from '../../SubTextContainer';
import ButtonContainer from '../../ButtonContainer';
export default {
  name: 'Offline',
  components: { SubTextContainer, ButtonContainer, StepTitle },
};
</script>
<style lang="scss" scoped>
.intro-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

.intro-image {
  width: 600px;
  max-width: 100%;
}

.top-sub-title {
  font-size: 26px;
  line-height: 23px;

  @media print, screen and (max-width: 400px) {
    font-size: 20px;
  }
}

.proceed-button {
  padding-left: 20px;
  padding-right: 20px;
}

.op-bezoek-tekst {
  width: 100%;
  max-width: 650px;
  margin-top: 30px;
  font-size: 16px;
  line-height: 22px;
}
</style>
